import { render, staticRenderFns } from "./Lobby3.vue?vue&type=template&id=5e663899"
import script from "./Lobby3.vue?vue&type=script&lang=js"
export * from "./Lobby3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports